
const Impressum = () => {
  return (
    <main className="min-h-screen bg-white py-16 px-4">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-4xl font-groteks mb-8">Impressum</h1>
        
        <div className="space-y-6">
          <h2 className="text-2xl font-groteks">Hiba Ganta</h2>
          
          <div className="space-y-2">
            <p className="font-inter">
              Address: Friedrich-Wilhelm Str. 23, 12103 Berlin
            </p>
            <p className="font-inter">
              VAT-ID: DE365568018
            </p>
            <p className="font-inter">
              E-Mail: <a href="mailto:hiba@rarefolks.com" className="text-primary hover:underline">hiba@rarefolks.com</a>
            </p>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Impressum;
